import { useState, useRef } from "react";
import ListRow from "./ListRow";
import css from "./List.module.css";
import SelectedMeasurement from "./SelectMeasurement";
import Section from "./section";
import Button from "./Button";

function List(props) {
  const draggingPosition = useRef(null);
  const dragOverPosition = useRef(null);

  const handleDragStart = (position) => {
    draggingPosition.current = position;
  };

  const handleDragEnter = (position) => {
    dragOverPosition.current = position;
    const newItems = [...props.items];
    const draggingItem = newItems[draggingPosition.current];
    if (!draggingItem) return;

    newItems.splice(draggingPosition.current, 1);
    newItems.splice(dragOverPosition.current, 0, draggingItem);

    const reorderedItems = newItems.map((item, index) => ({
      ...item,
      order: index,
    }));

    draggingPosition.current = position;
    dragOverPosition.current = null;

    props.move(reorderedItems);
  };

  const [selectedMeasurement, setSelectedMeasurement] = useState("both");

  const [enableDrag, setEnableDrag] = useState(false);

  function set(value) {
    setEnableDrag(value);
  }

  const listItems = props.items.map((item, index) => (
    <div
      key={item.key}
      draggable={enableDrag}
      onDragStart={() => handleDragStart(index)}
      onDragEnter={() => handleDragEnter(index)}
      onDragOver={(e) => e.preventDefault()}
    >
      <ListRow
        listName={props.listName}
        item={item}
        remove={props.remove}
        ingredientRow={props.ingredientRow}
        measurementType={selectedMeasurement}
        enableDrag={enableDrag}
        setEnableDrag={set}
      />
    </div>
  ));
  return (
    <Section>
      <div className={css.titleContainer}>
        <h1 className={css.title}>
          {props.ingredientRow ? props.listName + "s" : props.listName}
        </h1>
        <SelectedMeasurement
          ingredientRow={props.ingredientRow}
          setSelectedMeasurement={setSelectedMeasurement}
        />
      </div>
      <ul className={css.listItems}>{listItems}</ul>
      <Button onClick={() => props.add("")}>Add {props.listName}</Button>
    </Section>
  );
}

export default List;
